import React, { useEffect, useState } from 'react';
import SlickCarouselWithDateHighlight from '../../Carousel/SlickCarouselWithDateHighlight';
import { calculateCarouselData } from '../../../Helper/DigitalTwin/DigitalTwinFunctions';
import { changeDateFormat } from '../../../Helper/DatePicker/DateConverter';


export default function SingleAlertDateCarousel({
    currentDates,
    onChangeDate,
    primaryGranularity,
    currentAlert,
    alertInfo
}) {

    const [arrayOfDates, setArrayOfDatesFormatted] = useState([]);
    const [arrayOfDatesNumeric, setArrayOfDatesNumeric] = useState([]);
    const [carousalStartDate, setCarousalStartDate] = useState({});

    const statusColorMap = {
        'resolved': "#008000",
        'expired': '#A2A2A2',
    }


    const shouldAnnotate = (date) => {

        const startDate = changeDateFormat(currentAlert.activatedAt, 'YYYY-MM-DD')
        let endDate = currentAlert.resolvedAt ? changeDateFormat(currentAlert.resolvedAt, 'YYYY-MM-DD') : undefined

        if (currentAlert.expiredAt && !currentAlert.resolvedAt) {
            endDate = changeDateFormat(currentAlert.expiredAt, 'YYYY-MM-DD')
        }

        if (!endDate) {
            endDate = changeDateFormat(new Date(), 'YYYY-MM-DD')
        }

        if (date >= startDate && date <= endDate) {
            let annotateColor = "#CC4E01";

            if (date === endDate) {
                annotateColor = statusColorMap[currentAlert.alertStatus] || annotateColor
            }

            return {
                shouldAnnotate: true,
                annotateColor: annotateColor
            }
        }

        return {
            shouldAnnotate: false,
            annotateColor: "#C8D1DA"
        }
    }

    const setCarousalDate = (dateString, params = {}) => {
        setCarousalStartDate({ dateString });
        onChangeDate(dateString);
    };

    const createCarousalDateRanges = () => {
        const { startDate, endDate } = currentDates
        const [carousalDate, tempFormatted, tempNumeric] = calculateCarouselData(startDate, endDate, primaryGranularity)
        setArrayOfDatesFormatted(tempFormatted);
        setArrayOfDatesNumeric(tempNumeric);

        // set Alert date by default
        const selectedDateValue = currentAlert.expiredAtDate || currentAlert.resolvedAtDate || currentAlert.activatedAtDate || carousalDate[0]
        setCarousalDate(selectedDateValue);
    };


    useEffect(() => {
        createCarousalDateRanges();
    }, [currentDates, primaryGranularity]);


    return (
        <SlickCarouselWithDateHighlight
            Data={arrayOfDates}
            actualDates={arrayOfDatesNumeric}
            setTheDate={setCarousalDate}
            startDate={carousalStartDate?.dateString}
            slidesToShow={primaryGranularity === "raw" ? 5 : 3}
            shouldAnnotate={(date) => shouldAnnotate(date)}
            dataGapDates={alertInfo?.dataGaps}
        />
    )
}
